<template>
  <div class="description-content" v-if="numberQuestion === questionNumber">
    <div @click="manageShowsCloseOrOpen" v-if="title !== undefined">
      <Card 
        class='h-3rem mb-5 bg-gray-100 text-gray-800 shadow-md border border-gray-300 backdrop-blur-sm cursor-pointer' 
        test-id="identikitDescriptionsList"
      >
        <template #content>
          <div class="flex justify-content-between">
            <p class="-mt-3 -ml-1 font-semibold">{{title}}</p>
            <i :class="`pi pi-angle-${show ? 'up' : 'down'} text-2xl -mt-3 chevron-color`" />
          </div>
        </template>
      </Card>
    </div>
    <div class="dropdown-container">
      <div v-for="(dropdownOption, index) in this.dropdowns">
        <div :test-id="'identikitAutocomplete' + dropdownOption.optionTitle" v-if="(show || title === undefined)">
          <label>{{dropdownOption.optionTitle}}</label>
          <Dropdown 
            class="dropdown-question" 
            v-model="dynamicVModels[index]" 
            @change="updateDropdown(dropdownOption.optionsName, index, dropdownOption?.updateOtherDropdown)" 
            :options="dropdownOption?.dynamicOptions === true ? dynamicOptions[dropdownOption.optionTitle] : dropdownOption.optionsList" 
            :optionLabel="dropdownOption.optionLabel !== undefined ? dropdownOption.optionLabel : 'nombre'" 
            :placeholder="dropdownOption.optionTitle" 
            :filter="(dropdownOption?.dynamicOptions === true ? dynamicOptions[dropdownOption.optionTitle]?.length : dropdownOption.optionsList?.length) >= 5" 
            :ref="dropdownOption.optionTitle" 
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    id: String,
    numberQuestion: Number,
    questionNumber: Number,
    valueShow: Object,
    title: String,
    dropdowns: Array
  },
  name: 'DropdownAccordion',
  data() { 
    return {
      show: false,
      dynamicVModels: [],
      dynamicOptions: {}
    }
  },
  mounted(){
    this.initializingDynamicVModels();
  },  
  methods: {                     
    getOptionsList(listName){
      return this[listName];
    },
    updateDropdown(optionsName, index, updateOtherDropdown){
      if(updateOtherDropdown !== undefined) this.changeOptionLists(updateOtherDropdown, this.dynamicVModels[index]);
      this.$emit("updateDropdownData", optionsName, this.dynamicVModels[index]);
    },
    manageShowsCloseOrOpen(){
      this.$emit("closeAllAccordions", this.id);
      this.show = !this.show;
    },
    initializingDynamicVModels(){
      for(let i = 0; i < this.dropdowns.length; i++) {
        let defaultValue = {};
        this.dynamicVModels[i] = defaultValue;
      }
    },
    changeOptionLists(updateOtherDropdown, value){
      let nameProp;
      for(let i = 0; i < updateOtherDropdown.length; i++) {
        nameProp = Object.keys(updateOtherDropdown[i])[0];
        this.dynamicOptions[nameProp] = updateOtherDropdown[i][nameProp][value.nombre];
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.description-content{
  margin-top: 2rem;
}
.chevron-color{
  color: #7d858c;
}
.dropdown-container {
  display: flex;
  flex-direction: column;
  width: 100%; 
  gap: 10px;
}
.dropdown-question {
  width: 100%;
  margin-bottom: 20px;
}
</style>
